module.exports = __webpack_public_path__ + "img/green-gift-box.8dc62681.svg";